import { ENABLE_CRUISE_BOOKING_TYPE_FLAG } from './constants';

/**
 *
 * @param {object} booking - Booking object with `type` and `country.code`.
 * @param {object} ldFlags - LaunchDarkly flags object (data.ldFlags).
 * @returns {boolean}
 */
export const isRestrictedBooking = (booking, ldFlags) => {
  if (!booking || !ldFlags) {
    return false;
  }

  const flightBookingRestrictions =
    ldFlags[ENABLE_CRUISE_BOOKING_TYPE_FLAG]?.flightBookingRestrictions;

  if (!flightBookingRestrictions) {
    return false;
  }

  const { restrictedBookingTypes = [], restrictedMarkets = [] } = flightBookingRestrictions;

  const isRestrictedBookingType = restrictedBookingTypes.includes(booking?.type);
  const isRestrictedMarket = restrictedMarkets.includes(booking?.country?.code);

  return isRestrictedBookingType && isRestrictedMarket;
};

/**
 * Login-flow helper: unwraps a RETRIEVE_BOOKING result before checking.
 *
 * @param {object} bookingData - RETRIEVE_BOOKING result ({ retrieveBooking: { booking } }).
 * @param {object} ldFlags - LaunchDarkly flags object (data.ldFlags).
 * @returns {boolean}
 */
const isRestrictedBookingInMarket = (bookingData, ldFlags) =>
  isRestrictedBooking(bookingData?.retrieveBooking?.booking, ldFlags);

export default isRestrictedBookingInMarket;
